import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    token: null,
    userInfo: null
  },
  reducers: {
    setUser: (state, action) => {
      state.token = action.payload.token;
      if (action.payload.userInfo) {
        state.userInfo = action.payload.userInfo;
      }
    },
    clearUser: (state) => {
      state.token = null;
      state.userInfo = null;
    }
  }
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
